(function () {
    'use strict';

    a3_cabin_reports.directive('gradingReadOnly', gradingReadOnly);
    /**
    * @memberof CabinReports
    * @ngdoc directive
    * @name gradingReadOnly
    * @restrict E
    * @description
    *    Implementation of grading read only
    * @example
    *   Usage:
    *   <grading-read-only></grading-read-only>
    * @ngInject
    */
    function gradingReadOnly() {
        function link(scope, element, attrs) {
           if(scope.settings){
               scope.grading.GradeType = scope.settings.GradeType;
           }
        }

        return {
            restrict: 'E',
            terminal: false,
            templateUrl: 'views/TrainingReadOnly/grading-read-only.tpl.html',
            scope: {grading : "=", settings : "="},
            link: link
        }
    }

})();
